import { apiFetch } from './client';

export interface MyPermissions {
  role: string | null;
  userType: string;
  permissions: string[];
}

export interface RoleConfig {
  role: string;
  label: string;
  permissions: string[];
  updatedAt: string;
  updatedBy: string | null;
}

export interface PermissionDef {
  code: string;
  label: string;
}

export const rbacApi = {
  myPermissions: () => apiFetch<MyPermissions>('/users/me/permissions'),
  catalog: () => apiFetch<{ permissions: PermissionDef[] }>('/admin/rbac/catalog'),
  listRoles: () => apiFetch<{ roles: RoleConfig[] }>('/admin/rbac/roles'),
  updateRole: (role: string, permissions: string[]) =>
    apiFetch<{ role: string; permissions: string[]; updatedAt: string }>(
      `/admin/rbac/roles/${role}`,
      { method: 'PUT', body: JSON.stringify({ permissions }) },
    ),
};
